import React from "react";
import "../ModalMouqabale.styles.scss";
import {
  TCreneau,
  TMiniProfil,
  TMouqabalaStep,
} from "@/features/profile/types";
import { Button } from "@mui/material";
import { InlineIcon } from "@iconify/react";

interface MouqExistingProps {
  setStep?: React.Dispatch<React.SetStateAction<TMouqabalaStep>>;
  close?: () => void;
  receiver: TMiniProfil | null;
  selectedCreneau: Partial<TCreneau>;
}
const MouqExisting = ({
  close,
  receiver,
  selectedCreneau,
}: MouqExistingProps) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <div className="rules confirm-alt">
        <div className="rules__icon-success">
          <InlineIcon icon="akar-icons:circle-check" className="icon" />
        </div>
        <p className="rules__title-alt">
          Une Demande de mouqabala avec{" "}
          <span style={{ color: "var(--ui-tertiary-shade" }}>
            {receiver?.username}
          </span>{" "}
          a déjà été enregistrée
        </p>

        <Button
          variant="contained"
          className="rules__confirm"
          onClick={() => {
            close!();
          }}
          color="primary"
        >
          Retour à la discussion
        </Button>
      </div>
    </div>
  );
};

export default MouqExisting;
